import { CartProductDto } from "./cartProduct.dto";

export class CartProductSplitRequestDto {
  cartProduct: CartProductDto;
  quantity: number;
  saleUnitCartId: number;
  saleUnitCartSplitId?: number;
}
